import { render } from "./PageNavi.vue?vue&type=template&id=6e8716bf&scoped=true&ts=true"
import script from "./PageNavi.vue?vue&type=script&lang=ts"
export * from "./PageNavi.vue?vue&type=script&lang=ts"

import "./PageNavi.vue?vue&type=style&index=0&id=6e8716bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8716bf"]])

export default __exports__